module.exports = __webpack_public_path__ + "img/program-overview-banner.a45b1b0f.jpg";